import React from 'react'
import { useTar } from '@/modules/i18n/useTar'

export function Logo({ className, short }: { className?: string, short?: boolean }) {
    const { t } = useTar()
    const [visible, setVisible] = React.useState(false)

    React.useEffect(() => {
        setVisible(true)
    }, [])

    return (
        <span
            className={`font-bruno-ace-sc font-bold bg-gradient-to-r from-emerald-600 via-green-500 to-emerald-600 bg-clip-text text-transparent animate-gradient bg-[length:200%_auto] whitespace-nowrap ${className}`}
            style={{
                opacity: visible ? 1 : 0,
                transition: 'opacity 1200ms ease',
            }}
        >
            {short ? t('common.appNameShort') : t('common.appName')}
        </span>
    )
}
